import React from 'react';
import PropTypes from 'prop-types';

import { FormatPrice } from 'utils/format';

import { Icon, Flexer } from '@ontruck/orc';

const CarrierRevenueCell = ({ cost, currency, ...props }) => {
  return (
    <Flexer.Parent alignItems="center" {...props}>
      <Flexer.Child mRight="XS">
        <Icon glyph="truck" size="1.6rem" color="grey500" />
      </Flexer.Child>
      <Flexer.Child>
        <FormatPrice currency={currency} value={cost} />
      </Flexer.Child>
    </Flexer.Parent>
  );
};

CarrierRevenueCell.propTypes = {
  cost: PropTypes.number,
  currency: PropTypes.string,
};

export default CarrierRevenueCell;
